<template>

  <div>
    <main class="content content--narrow" v-if="typeof user.uuid !== 'undefined'">

      <div class="content__heading content__heading--center">
        <h1>
          <i class="icon--plans"></i> {{ status_title }}
        </h1>
      </div>

      <section class="content--boxed">

        {{ status_message }}

        <div class="btn--bar">

          <router-link class="btn btn--center" :to="{ name: 'payment.index'}">
            {{ $t('general.payment') }}
          </router-link>

        </div>

      </section>
    </main>
  </div>

</template>

<script>
export default {
  name: 'Payment-Staus',
  components: {},
  mounted () {
    this.init()
  },
  data: () => {
    return {
      status_message: null,
      status_title: null
    }
  },
  methods: {
    init () {
      if (typeof this.user.has_mandate !== 'undefined' && !this.user.has_mandate) {
        this.status_message = this.$t('payment.incomplete')
        this.status_title = this.$t('payment.incompleteTitle')
      } else {
        this.status_message = this.$t('payment.success')
        this.status_title = this.$t('payment.successTitle')
      }
    }
  }
}
</script>

<style scoped>

</style>
